import React, { useCallback, useEffect, useState } from 'react';
import { Package } from '@phosphor-icons/react';
import { myPlanService } from '../../../services/plans/myPlanService.js';
import { myCompanyService } from '../../../services/companies/myCompanyService.js';
import PageHeader from '../../../shared/components/ui/PageHeader.jsx';
import MyPlanSummaryCard from '../components/MyPlanSummaryCard.jsx';
import MyPlanEmptyState from '../components/MyPlanEmptyState.jsx';
import MyPlanErrorState from '../components/MyPlanErrorState.jsx';

const MyPlanScreen = () => {
  const [plan, setPlan] = useState(null);
  const [companyPlanId, setCompanyPlanId] = useState(null);
  const [technicianCount, setTechnicianCount] = useState(0);
  const [storage, setStorage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const [planData, companyData] = await Promise.all([
        myPlanService.getMyPlan(),
        myCompanyService.getMyCompany()
      ]);
      setPlan(planData);
      setCompanyPlanId(companyData.company.planId);
      setTechnicianCount(companyData.technicianCount);
      setStorage(companyData.storage);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  return (
    <div className="flex flex-col">
      <PageHeader
        title="Plan"
        subtitle="Consulta el plan contratado y el consumo actual de tu empresa."
        icon={<Package size={28}/>}
      />
      <div className="px-4 py-4">
        {loading && (
          <div className="flex items-center justify-center py-24 text-content-muted">Cargando...</div>
        )}
        {!loading && error && <MyPlanErrorState onRetry={fetchAll} />}
        {/* M2: la señal de "sin plan" es company.planId, no el resultado de /myPlan
            (su comportamiento sin plan asignado no está documentado por backend). */}
        {!loading && !error && !companyPlanId && <MyPlanEmptyState />}
        {!loading && !error && companyPlanId && (
          <MyPlanSummaryCard plan={plan} technicianCount={technicianCount} storage={storage} />
        )}
      </div>
    </div>
  );
};

export default MyPlanScreen;
